// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_71e7feac","title":"_abe4b15f","copy":"_28bb5da","message":"_cdf517f4","messageBold":"_42e59ab1"};